// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o1-5";
export var filledCircle = "_o1-4";
export var historyEntry = "_o1-3";
export var messageSideLeft = "_o1-1";
export var messageSideRight = "_o1-2";
export var orderTrackingCarouselWrapper = "_o1-6";
export var orderTrackingInfoContainer = "_o1-0";